/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aitexteventpromptplaceholder4Inputs */

const en_aitexteventpromptplaceholder4 = /** @type {(inputs: Aitexteventpromptplaceholder4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Summer open air with three live bands, food trucks, doors at 6pm`)
};

const de_aitexteventpromptplaceholder4 = /** @type {(inputs: Aitexteventpromptplaceholder4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z. B. Sommer-Openair mit drei Live-Bands, Foodtrucks, Einlass ab 18 Uhr`)
};

/**
* | output |
* | --- |
* | "e.g. Summer open air with three live bands, food trucks, doors at 6pm" |
*
* @param {Aitexteventpromptplaceholder4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aitexteventpromptplaceholder4 = /** @type {((inputs?: Aitexteventpromptplaceholder4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aitexteventpromptplaceholder4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aitexteventpromptplaceholder4(inputs)
	return de_aitexteventpromptplaceholder4(inputs)
});
export { aitexteventpromptplaceholder4 as "aiTextEventPromptPlaceholder" }